import Link from 'next/link'

import type { AnchorItem } from '@/components/page-anchors/PageAnchors'

export default function PageAnchorsList({
  anchors,
  label = 'On this page:',
}: {
  anchors: AnchorItem[]
  label?: string | false
}) {
  const anchorClass = `
    block
    bg-theme-accent
    rounded-full
    text-fg
    text-[length:--p-s-size]
    font-bold
    text-primary
    py-xs
    px-m
    transition-colors
    duration-150

    hover:bg-primary
    hover:text-white
  `

  // Fallback for when label is empty
  if (label !== false) {
    label = label?.length ? label : 'On this page:'
  }

  return (
    <div className="component component--downloads no-list-styles">
      <div className="container @container @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
        {label ? <span className="h6 mb-m">{label}</span> : null}

        <ul className="flex flex-wrap gap-s">
          {anchors.map((anchor, index) => (
            <li key={index}>
              <Link href={`#${anchor.anchor_id}`} className={anchorClass}>
                {anchor.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
